import { NAV_ITEMS } from '@/constants';
import barsIcon from '@iconify/icons-ant-design/bars-outline';
import { NavItem } from '../../nav-item';
import { useVerticalBarNavigation } from '../use-vertical-bar-navigation';

export const ListNavItem = () => {
  const { goToTab, pathname } = useVerticalBarNavigation();

  return (
    <NavItem
      id="list"
      icon={barsIcon}
      tooltip="List"
      ariaLabel="Go to List View"
      isActive={pathname.includes(NAV_ITEMS.list)}
      onClick={() => {
        goToTab(NAV_ITEMS.list);
      }}
    />
  );
};
